import axios from '../../http.service';
import {
	REPORT_ERROR,
	SEARCH_BY_UNIQUE_PARAM,
	SEARCH_BY_NAME_DOB,
	SEARCH_FAILED,
	REMOVE_APPOINTEE,
	GET_APSAPPOINTEEDATA,
	GET_APSAPPOINTEEDATAEXPORT,
	GET_APSAPPOINTEEDATADETAILS,
	GET_APPOINTEECONTRACTRESPONSEDATA,
	GET_APPOINTEECONTRACTRESPONSEDATAEXPORT,
	GET_APPOINTEECONTRACTRESPONSEDATADETAILS,
	GET_APPOINTEEEXCEPTIONREASON,
	GET_APPOINTEEEXCEPTIONREASONEXPORT,
	GET_APPOINTEEEXCEPTIONREASONDETAILS
} from '../Enums/Appointee.Contract.Enums';

const apiUrl = process.env.REACT_APP_SERVER || 'http://localhost:3001/api';

export const searchById = appointeeId => {
	return async dispatch => {
		try {
			let resp = await axios.get(`${apiUrl}/appointee/id/${appointeeId}`);
			if (resp.data.success) dispatch({ type: SEARCH_BY_UNIQUE_PARAM, payload: resp.data });
			else
				dispatch({
					type: SEARCH_FAILED,
					payload: {
						data: resp.data,
						errorMessage: `Appointee with ID: ${appointeeId} could not be found.`
					}
				});
		} catch (err) {
			dispatch({
				type: SEARCH_FAILED,
				payload: { errorMessage: err.message }
			});
		}
	};
};

export const searchByNino = nino => {
	return async dispatch => {
		try {
			let resp = await axios.get(`${apiUrl}/appointee/nino/${nino}`);
			if (resp.data.success) dispatch({ type: SEARCH_BY_UNIQUE_PARAM, payload: resp.data });
			else
				dispatch({
					type: SEARCH_FAILED,
					payload: {
						data: resp.data,
						errorMessage: `Appointee with National Insurance No: ${nino} could not be found.`
					}
				});
		} catch (err) {
			dispatch({
				type: SEARCH_FAILED,
				payload: { errorMessage: err.message }
			});
		}
	};
};

export const searchByNameAndDob = (forename, surname, dob) => {
	return async dispatch => {
		try {
			let resp = dob
				? await axios.get(`${apiUrl}/appointee/search/namedob?forename=${forename}&surname=${surname}&dob=${dob}`)
				: await axios.get(`${apiUrl}/appointee/search/name?forename=${forename}&surname=${surname}`);

			if (resp.data.success) dispatch({ type: SEARCH_BY_NAME_DOB, payload: resp.data });
			else
				dispatch({
					type: SEARCH_FAILED,
					payload: {
						data: resp.data,
						errorMessage: `No Appointees Found Matching: Forename- ${forename}, Surname- ${surname}, Date Of Birth- ${dob}.`
					}
				});
		} catch (err) {
			dispatch({
				type: SEARCH_FAILED,
				payload: { errorMessage: err.message }
			});
		}
	};
};

export const removeAppointeeById = appointeeId => {
	return dispatch => {
		try {
			dispatch({ type: REMOVE_APPOINTEE, payload: { appointeeId } });
		} catch (err) {
			console.error(err);
		}
	};
};

export const getAPSAppointee = (year, appointmentTypes, query) => {
	return async dispatch => {
		try {
			let types = Object.assign({}, appointmentTypes);
			let resp = await axios.get(`/api/v2/appointeeReducer/apsappointeedata/${year}/${JSON.stringify(types)}?pagination=${JSON.stringify(query)}`);
			resp.status === 200 ? dispatch({ type: GET_APSAPPOINTEEDATA, payload: resp.data }) : dispatch({ type: REPORT_ERROR, payload: resp.data });
		} catch (error) {
			dispatch({
				type: REPORT_ERROR,
				payload: {
					data: [],
					errors: ['Error while fetching APS Appointee Data', error.message]
				}
			});
		}
	};
};

export const getAPSAppointeeExport = (year, appointmentTypes, query) => {
	return async dispatch => {
		try {
			let types = Object.assign({}, appointmentTypes);
			let resp = await axios.get(`/api/v2/appointeeReducer/apsappointeedata/${year}/${JSON.stringify(types)}?pagination=${JSON.stringify(query)}`);
			resp.status === 200
				? dispatch({
						type: GET_APSAPPOINTEEDATAEXPORT,
						payload: resp.data
				  })
				: dispatch({ type: REPORT_ERROR, payload: resp.data });
		} catch (error) {
			dispatch({
				type: REPORT_ERROR,
				payload: {
					data: [],
					errors: ['Error while fetching APS Appointee Data', error.message]
				}
			});
		}
	};
};

export const getAPSAppointeeDetails = (markingTeamId, year, markingTeamCode, appointmentTypes, query) => {
	return async dispatch => {
		try {
			let types = Object.assign({}, appointmentTypes);
			let resp = await axios.get(
				`/api/v2/appointeeReducer/apsappointeedata/details/${markingTeamId}/${year}/${markingTeamCode}/${JSON.stringify(
					types
				)}?pagination=${JSON.stringify(query)}`
			);
			resp.status === 200
				? dispatch({
						type: GET_APSAPPOINTEEDATADETAILS,
						payload: resp.data
				  })
				: dispatch({ type: REPORT_ERROR, payload: resp.data });
		} catch (error) {
			dispatch({
				type: REPORT_ERROR,
				payload: {
					data: [],
					errors: ['Error while fetching APS Appointee Details Data', error.message]
				}
			});
		}
	};
};

export const getAppointeeContractResponse = (year, appointmentTypes, query) => {
	return async dispatch => {
		try {
			let types = Object.assign({}, appointmentTypes);
			let resp = await axios.get(
				`/api/v2/appointeeReducer/appointeecontractresponsedata/${year}/${JSON.stringify(types)}?pagination=${JSON.stringify(query)}`
			);
			resp.status === 200
				? dispatch({
						type: GET_APPOINTEECONTRACTRESPONSEDATA,
						payload: resp.data
				  })
				: dispatch({ type: REPORT_ERROR, payload: resp.data });
		} catch (error) {
			dispatch({
				type: REPORT_ERROR,
				payload: {
					data: [],
					errors: ['Error while fetching APS Appointee Data', error.message]
				}
			});
		}
	};
};

export const getAppointeeContractResponseExport = (year, appointmentTypes, query) => {
	return async dispatch => {
		try {
			let types = Object.assign({}, appointmentTypes);
			let resp = await axios.get(
				`/api/v2/appointeeReducer/appointeecontractresponsedata/${year}/${JSON.stringify(types)}?pagination=${JSON.stringify(query)}`
			);
			resp.status === 200
				? dispatch({
						type: GET_APPOINTEECONTRACTRESPONSEDATAEXPORT,
						payload: resp.data
				  })
				: dispatch({ type: REPORT_ERROR, payload: resp.data });
		} catch (error) {
			dispatch({
				type: REPORT_ERROR,
				payload: {
					data: [],
					errors: ['Error while fetching APS Appointee Data', error.message]
				}
			});
		}
	};
};

export const getAppointeeContractResponseDetails = (markingTeamId, year, markingTeamCode, appointmentTypes, query) => {
	return async dispatch => {
		try {
			let types = Object.assign({}, appointmentTypes);
			let resp = await axios.get(
				`/api/v2/appointeeReducer/appointeecontractresponsedata/details/${markingTeamId}/${year}/${markingTeamCode}/${JSON.stringify(
					types
				)}?pagination=${JSON.stringify(query)}`
			);
			resp.status === 200
				? dispatch({
						type: GET_APPOINTEECONTRACTRESPONSEDATADETAILS,
						payload: resp.data
				  })
				: dispatch({ type: REPORT_ERROR, payload: resp.data });
		} catch (error) {
			dispatch({
				type: REPORT_ERROR,
				payload: {
					data: [],
					errors: ['Error while fetching APS Appointee Details Data', error.message]
				}
			});
		}
	};
};

export const getAppointeeExceptionReason = (year, appointmentTypes, query) => {
	return async dispatch => {
		try {
			let types = Object.assign({}, appointmentTypes);
			let resp = await axios.get(
				`/api/v2/appointeeReducer/appointeeexceptionreason/${year}/${JSON.stringify(types)}?pagination=${JSON.stringify(query)}`
			);
			resp.status === 200
				? dispatch({
						type: GET_APPOINTEEEXCEPTIONREASON,
						payload: resp.data
				  })
				: dispatch({ type: REPORT_ERROR, payload: resp.data });
		} catch (error) {
			dispatch({
				type: REPORT_ERROR,
				payload: {
					data: [],
					errors: ['Error while fetching APS Appointee Data', error.message]
				}
			});
		}
	};
};

export const getAppointeeExceptionReasonExport = (year, appointmentTypes, query) => {
	return async dispatch => {
		try {
			let types = Object.assign({}, appointmentTypes);
			let resp = await axios.get(
				`/api/v2/appointeeReducer/appointeeexceptionreason/${year}/${JSON.stringify(types)}?pagination=${JSON.stringify(query)}`
			);
			resp.status === 200
				? dispatch({
						type: GET_APPOINTEEEXCEPTIONREASONEXPORT,
						payload: resp.data
				  })
				: dispatch({ type: REPORT_ERROR, payload: resp.data });
		} catch (error) {
			dispatch({
				type: REPORT_ERROR,
				payload: {
					data: [],
					errors: ['Error while fetching APS Appointee Data', error.message]
				}
			});
		}
	};
};

export const getAppointeeExceptionReasonDetails = (markingTeamId, year, markingTeamCode, appointmentTypes, query) => {
	return async dispatch => {
		try {
			let types = Object.assign({}, appointmentTypes);
			let resp = await axios.get(
				`/api/v2/appointeeReducer/appointeeexceptionreason/details/${markingTeamId}/${year}/${markingTeamCode}/${JSON.stringify(
					types
				)}?pagination=${JSON.stringify(query)}`
			);
			resp.status === 200
				? dispatch({
						type: GET_APPOINTEEEXCEPTIONREASONDETAILS,
						payload: resp.data
				  })
				: dispatch({ type: REPORT_ERROR, payload: resp.data });
		} catch (error) {
			dispatch({
				type: REPORT_ERROR,
				payload: {
					data: [],
					errors: ['Error while fetching APS Appointee Details Data', error.message]
				}
			});
		}
	};
};
